class ActionCounter {
	constructor(props) {
		if ( !this._initHtml(props) ) return false;

		this._initCounter();
	}
	_initHtml(props) {
		if (!props.root || !props.element) return false;

		this.root = props.element || document.querySelector(`[${props.root}]:not([${props.root}-inited])`);
		if (!this.root) return false;

		this.root.setAttribute(`${props.root}-inited`, true);
		this.words = {};

		['days', 'hours', 'mins'].forEach(el => {
			if (this.root.querySelector(`[${props.root}-${el}]`)){
				this[el] = this.root.querySelector(`[${props.root}-${el}]`);
				this[`${el}Placeholder`] = this.root.querySelector(`[${props.root}-${el}-placeholder]`);

				if (this[`${el}Placeholder`] !== null) {
					this.words[el] = this[`${el}Placeholder`].getAttribute(`${props.root}-${el}-placeholder`).split(';');
				}
			}
		});

		this.timeOff = new Date( this.root.getAttribute(`${props.root}`) );
		this.maxDays = this.root.dataset.marketingMaxDays;

		return true;
	}
	_initCounter() {
		this._update();

		this.root.classList.add('is-init');

		setInterval(_ => {
			this._update();
		}, 1000);
	}
	_update() {
		let now = new Date(),
			dif = this.timeOff - now,
			d = (dif > 0) ? this._dhm(dif) : [0,0,0];

		if (d[0] < 1) {
			if (this.days) this.days.innerText = '';
			if (this.daysPlaceholder) this.daysPlaceholder.innerText = '';

			if (this.hours) this.hours.innerText = d[1];
			if (this.mins) this.mins.innerText = d[2];
			if (this.hoursPlaceholder) this.hoursPlaceholder.innerText = this._getWord(d[1], 'hours');
			if (this.minsPlaceholder) this.minsPlaceholder.innerText = this._getWord(d[2], 'mins');
		} else {
			if (d[0] >= this.maxDays) {
				if (this.hours) this.hours.innerText = ''
				if (this.mins) this.mins.innerText = '';
				if (this.hoursPlaceholder) this.hoursPlaceholder.innerText = '';
				if (this.minsPlaceholder) this.minsPlaceholder.innerText = '';
				if (this.daysPlaceholder) this.daysPlaceholder.innerText = '';
				if (this.days) this.days.innerText = `Осталось ${this.maxDays} дн`;
			} else {
				if (this.days) this.days.innerText = `Осталось ${d[0]} дн`;
			}
		}

		let zeroChecker = 0;

		for (var i = d.length - 1; i >= 0; i--) {
			if (d[i] === 0) {
				zeroChecker++
			}
		}

		if (zeroChecker === d.length) {
			if (!this.root.classList.contains('is-hidden')){
				this.root.classList.add('is-hidden');
			}
		}


		// if (this.days) this.days.innerText = d[0];
		// if (this.hours) this.hours.innerText = d[1];
		// if (this.mins) this.mins.innerText = d[2];

		// this.daysPlaceholder.innerText = (d[0] % 10 === 1) ? this.words.days[0] : (d[0] % 10 > 1 && d[0] % 10 < 5) ? this.words.days[1] : this.words.days[2];
		// this.hoursPlaceholder.innerText = (d[1] % 10 === 1) ? this.words.hours[0] : (d[1] % 10 > 1 && d[1] % 10 < 5) ? this.words.hours[1] : this.words.hours[2];
		// this.minsPlaceholder.innerText = (d[2] % 10 === 1) ? this.words.mins[0] : (d[2] % 10 > 1 && d[2] % 10 < 5) ? this.words.mins[1] : this.words.mins[2];


		// if (this.daysPlaceholder) this.daysPlaceholder.innerText = this._getWord(d[0], 'days');
		// if (this.hoursPlaceholder) this.hoursPlaceholder.innerText = this._getWord(d[1], 'hours');
		// if (this.minsPlaceholder) this.minsPlaceholder.innerText = this._getWord(d[2], 'mins');




	}
	_dhm(t){
		var cd = 24 * 60 * 60 * 1000,
			ch = 60 * 60 * 1000,
			d = Math.floor(t / cd),
			h = Math.floor( (t - d * cd) / ch),
			m = Math.round( (t - d * cd - h * ch) / 60000),
			pad = function(n){ return n < 10 ? '0' + n : n; };

		if ( m === 60 ) {
			h++;
			m = 0;
		}

		if ( h === 24 ) {
			d++;
			h = 0;
		}

		// return [d, pad(h), pad(m)];
		return [d, h, m];
	}
	_getWord(number, key) {

		if (number >= 10 && number <= 20) {
			return this.words[key][2];
		} else {
			return (number % 10 === 1) ? this.words[key][0] : (number % 10 > 1 && number % 10 < 5) ? this.words[key][1] : this.words[key][2];
		}

	}
}

class ActionCounters {
	constructor(props) {
		if (!props.root) return false;

		let marketingOffers = [...document.querySelectorAll(`[${props.root}]:not([${props.root}-inited]`)];

		marketingOffers.forEach(marketingOffer => {
			new ActionCounter({
				root: props.root,
				element: marketingOffer
			});
		});
	}
}

export {ActionCounters, ActionCounter}
